import React from "react";
import { useLanguageForShared } from "../../../../../../shared/utils/languages/useLanguageForShared";
import { FormElements } from "../../../../../../shared/bootstrap/form/FormElements";
import { useParamsData, useParamsDataPL } from "./data/useParamsData";
import { useGenericProductData, useGenericProductDataPL } from "./data/useGenericProductData";

export function TemplateGenericProduct({ dataForm, changeValue, errors, setData, isSubmit }) {
    const { t } = useLanguageForShared()

    dataForm.issuedBy = dataForm.issuedBy || "philips"; //HACK: default su Philips

    //console.log(dataForm);

    const { formStructureModel, formStructureQuantity } = useGenericProductData(t, dataForm);
    const { formStructureNote, formStructureIssuedBy } = useParamsData(t, dataForm)
    
    return (
        <>
            <div className={'d-flex'}>
                <div className={'w-100'}>
                    <FormElements
                        isSubmit={isSubmit}
                        structure={formStructureModel}
                        dataForm={dataForm}
                        errors={errors}
                        changeValue={changeValue} />
                </div>
                <div className={'w-100'}>
                    <FormElements
                        isSubmit={isSubmit}
                        structure={formStructureQuantity}
                        dataForm={dataForm}
                        errors={errors}
                        changeValue={changeValue} />
                </div>
            </div>
            <div className={'d-flex'}>
                <div className={'w-50 d-flex'}>
                    <div class="w-75">
                        <FormElements
                            structure={formStructureNote}
                            dataForm={dataForm}
                            changeValue={changeValue}
                            errors={errors}
                            isSubmit={isSubmit}
                        />
                    </div>
                    <div class="w-25"></div>
                </div>
                <div className={'w-25'}>
                    <FormElements
                        structure={formStructureIssuedBy}
                        dataForm={dataForm}
                        changeValue={changeValue}
                        errors={errors}
                        isSubmit={isSubmit}
                    />
                </div>
            </div>
        </>
    );
}

export function TemplateGenericProductPL({ dataForm, changeValue, errors, setData, isSubmit }) {
    const { t } = useLanguageForShared()
    console.log(dataForm)
    const { formStructureModel, formStructureQuantity } = useGenericProductDataPL(t, dataForm);
    const {
        formStructureNote,
    } = useParamsDataPL(t, dataForm)

    return (
        <>
            <div className={'d-flex'}>
                <div className={'w-100'}>
                    <FormElements
                        isSubmit={isSubmit}
                        structure={formStructureModel}
                        dataForm={dataForm}
                        errors={errors}
                        changeValue={changeValue} />
                </div>
                <div className={'w-100'}>
                    <FormElements
                        isSubmit={isSubmit}
                        structure={formStructureQuantity}
                        dataForm={dataForm}
                        errors={errors}
                        changeValue={changeValue} />
                </div>
            </div>
            <FormElements
                structure={formStructureNote}
                dataForm={dataForm}
                changeValue={changeValue}
                errors={errors}
                isSubmit={isSubmit}
            />
        </>
    );
}
